import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';


i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Bind to React
  .init({
    fallbackLng: 'zh', // Default language
    resources: {
      en: {
        translation: {
          "login": "Login",
          "sign_up": "Sign Up",
          "country_code": "Country code",
          "phone_number": "Phone Number",
          "phone_no_placeholder": "Enter your phone number",
          "receive_PIN": "Receive PIN",
          "PIN": "PIN",
          "PIN_placeholder": "Enter your PIN",
          "next": "Next",
          "internal_code": "Internel Code",
          "internal_code_placeholder": "Internel Code (Optional)",
          "password": "Password",
          "password_placeholder": "Enter password",
          "sign_up_account": "Sign up account",
          "you_remain": "You remain",
          "quota_to_generate_images": "quota to generate images",
          "choose_colours": "Choose colour(s):",
          "choose_a_shape": "Choose a shape:",
          "describe_your_desired_rings": "Describe your desired rings:",
          "X-shape": "X-shape",
          "V-shape": "V-shape",
          "olive": "olive",
          "crossed": "crossed",
          "straight": "straight",
          "geometry": "geometry",
          "step": "step",
          "twist": "twist",
          "curve": "curve",
          "special": "special",
          "upper": "upper",
          "thick": "thick",
          "wave": "wave",
          "triangle": "triangle",

          // colour selected by user
          "gold": "gold",
          "rose gold": "rose gold",
          "platinum": "platinum",

          "keyword":"Enter your keyword, eg: shining, rose pattern ",
          "generate": "Generate",
          "add_favourite": "Add Favourite",
          "download_the_image_and_contact_diaholic": "Download the image and contact diaholic",
          "logout": "Logout",
          "book_your_customized_ring": "book your customized ring", 
          "contact": "Contact",
          "find_diaholic_instagram": "Find diaholic at instagram"
        }
      },
      zh: {
        translation: {
          "login": "登入",
          "sign_up": "註冊",
          "country_code": "區號",
          "phone_number": "電話號碼",
          "phone_no_placeholder": "輸入你的電話號碼",
          "receive_PIN": "接收 PIN 碼",
          "PIN": "PIN",
          "PIN_placeholder": "輸入 PIN 碼",
          "next": "繼續",
          "internal_code": "內部碼",
          "internal_code_placeholder": "內部碼 (可以留空)",
          "password": "密碼",
          "password_placeholder": "輸入密碼",
          "sign_up_account": "註冊帳號",
          "you_remain": "你餘下",
          "quota_to_generate_images": "次限額",
          "choose_colours": "選擇顏色:",
          "choose_a_shape": "選擇形狀:",
          "describe_your_desired_rings": "描述您想要的戒指:",
          "straight": "直的",
          "X-shape": "X形",
          "V-shape": "V形",
          "olive": "橄欖",
          "crossed": "十字形",
          "geometry": "幾何",
          "step": "階梯",
          "twist": "渦狀形",
          "curve": "弧形",
          "special": "特殊",
          "upper": "直的(上層)",
          "thick": "厚",
          "wave": "波浪形",
          "triangle": "三角形",

          // colour selected by user
          "gold": "金",
          "rose gold": "玫瑰金",
          "platinum": "白金",

          "keyword":"輸入關鍵字，例如: 大海",
          "generate": "生成",
          "add_favourite": "加入最愛",
          "download_the_image_and_contact_diaholic": "下載圖片及聯絡Diaholic",
          "logout": "登出",
          "book_your_customized_ring":"預訂您的訂製戒指",
          "contact": "聯絡",
          "find_diaholic_instagram": " Diaholic 在 instagram"
        }
      }
    },
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n;
